import '../../style/style.css'

const SidebarFooter = () => {
  return (
    <div className='app-sidebar-footer flex-column-auto py-1 px-6' id='kt_app_sidebar_footer'>
      <a
        target='_blank' 
        className='sidebarLogoutButton'
        style={{marginBottom:'0.8px', cursor: 'pointer'}}
        data-bs-toggle='tooltip'
        data-bs-trigger='hover'
        data-bs-dismiss-='click'
        onClick={() => { window.location.href = "/logout" }}
      >
        <span className="logout-icon ">
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.16732 12.5H14.0632M6.25065 15.625L3.12565 12.5L6.25065 9.37496M11.459 7.29163V6.24996C11.459 5.69742 11.6785 5.16752 12.0692 4.77682C12.4599 4.38612 12.9898 4.16663 13.5423 4.16663H18.7507C19.3032 4.16663 19.8331 4.38612 20.2238 4.77682C20.6145 5.16752 20.834 5.69742 20.834 6.24996V18.75C20.834 19.3025 20.6145 19.8324 20.2238 20.2231C19.8331 20.6138 19.3032 20.8333 18.7507 20.8333H13.5423C12.9898 20.8333 12.4599 20.6138 12.0692 20.2231C11.6785 19.8324 11.459 19.3025 11.459 18.75V17.7083" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span className='logout-text'>
          Çıkış
        </span>
      </a>
    </div>
  )
}

export { SidebarFooter }
